module.exports = __webpack_public_path__ + "static/profileAnn-7fb43b7baa6cb85b7de72b17fc97708f.jpg";